__turbopack_context__.v({
  "button-container": "PlaylistTrack-module-scss-module__UbqHvq__button-container",
  "liveBadge": "PlaylistTrack-module-scss-module__UbqHvq__liveBadge",
  "liveBadgeCircle": "PlaylistTrack-module-scss-module__UbqHvq__liveBadgeCircle",
  "mobile": "PlaylistTrack-module-scss-module__UbqHvq__mobile",
  "playlist-track--thumbnail": "PlaylistTrack-module-scss-module__UbqHvq__playlist-track--thumbnail",
  "playlistTrack": "PlaylistTrack-module-scss-module__UbqHvq__playlistTrack",
  "playlistTrackClipTitle": "PlaylistTrack-module-scss-module__UbqHvq__playlistTrackClipTitle",
  "playlistTrackDetails": "PlaylistTrack-module-scss-module__UbqHvq__playlistTrackDetails",
  "playlistTrackDurationPlays": "PlaylistTrack-module-scss-module__UbqHvq__playlistTrackDurationPlays",
  "playlistTrackLiveDetails": "PlaylistTrack-module-scss-module__UbqHvq__playlistTrackLiveDetails",
  "playlistTrackLiveViewerIcon": "PlaylistTrack-module-scss-module__UbqHvq__playlistTrackLiveViewerIcon",
  "playlistTrackLiveViewercount": "PlaylistTrack-module-scss-module__UbqHvq__playlistTrackLiveViewercount",
  "selected": "PlaylistTrack-module-scss-module__UbqHvq__selected",
});
